import { useEffect, useRef, useState } from "react";
import { formatNum } from "@/lib/api";

export function AnimatedNumber({ value, className, testid }) {
  const [display, setDisplay] = useState(value || 0);
  const fromRef = useRef(value || 0);

  useEffect(() => {
    const from = fromRef.current;
    const to = Number(value) || 0;
    if (from === to) return;
    const start = performance.now();
    const dur = 900;
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(from + (to - from) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
      else fromRef.current = to;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value]);

  return <span className={className} data-testid={testid}>{formatNum(display)}</span>;
}
